// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"de503d9c","324":"dbe75f74","791":"29499bd5","816":"27a9ef7c"}[chunkId] + ".chunk.js";
};